<template>
  <div v-if="news !== null">
    <!-- 文章資訊 -->
    <div class="block mb-5">
      <!-- News Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>News Tilte</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="news.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Tab -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Tab</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <SimpleSelectWithSearchInput
            class="mr-5"
            buttonPlaceholder="選擇Tab"
            :isOnlyShowButtonPlaceholder="true"
            buttonWidth="160px"
            modalWidth="200px"
            :options="newsTypeOptions"
            :selectedValue.sync="news.tab"
          ></SimpleSelectWithSearchInput>
        </div>
      </div>
      <!-- 設定日期 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-3">設定日期</h4>
          <div class="h5 ink-02-medium--text mb-3">
            前台將依設定日期顯示文章的發佈日
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex">
          <v-menu
            v-model="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="news.published_at"
                placeholder="請選擇日期"
                outlined
                dense
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="news.published_at"
              @input="dateMenu = false"
            ></v-date-picker>
          </v-menu>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="news.status"></FormSwitch>
        </div>
      </div>
      <!-- 置頂精選 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>置頂精選</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-checkbox v-model="news.is_top">
            <template v-slot:label>
              <div class="h5 ink-01-emphasis--text">
                設定為置頂精選
              </div>
            </template>
          </v-checkbox>
        </div>
      </div>
      <!-- 置頂圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">置頂圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於新聞列表Overview頁面 <br />
            建議尺寸：1600px * 900px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="news.top_image"
            dir="news"></ImgUploader>
        </div>
      </div>
      <!-- 封面圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">封面圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於新聞列表Overview頁面 <br />
            建議尺寸：430px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="news.cover_image"
            dir="news"></ImgUploader>
        </div>
      </div>
      <!-- News Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="news.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Summary -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Summary</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-textarea
            v-model="news.summary"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
    </div>

    <!-- TextEditor -->
    <editor
      v-model="news.content"
      :height="600"
      :plugins="'link image lists'"
      :toolbar="'undo redo | link|fontsize select forecolor|image|bullist numlist|outdent indent|alignleft aligncenter alignright|bold'"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SimpleSelectWithSearchInput from '@/components/Selection/SimpleSelectWithSearchInput.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    SimpleSelectWithSearchInput,
    FormSwitch,
    ImgUploader,
    Editor,
  },
  data: () => ({
    tab: '',
    isShow: false,
    isTop: false,
    dateMenu: false,
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('news', ['news', 'newsTypeOptions']),
  },
  methods: {
  },
};
</script>

<style></style>
